import { CommunityEntityType } from 'generated/graphql';

export const composeTypeText = (type: CommunityEntityType | undefined | null) => {
  switch (type) {
    case 'Team':
      return 'Team';

    default:
      return 'Community';
  }
};
